export default __webpack_public_path__ + "static/media/overview_icon_1.eab0b953.png";